import React, { useContext, useEffect } from "react";
import { Table, Segment } from "semantic-ui-react";
import AssetStore from "../../../app/stores/assetStore";
import { observer } from "mobx-react-lite";

const EmployeeAssetList: React.FC = () => {
  const assetStore = useContext(AssetStore);
  const { employeeAssetsByCode, loadEmployeeAssets } = assetStore;
  useEffect(() => {
    loadEmployeeAssets();
  }, []);
  return (
    <Segment>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Model</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {employeeAssetsByCode.map((asset) => (
            <Table.Row key={asset.id}>
              <Table.Cell>{asset.assetName}</Table.Cell>
              <Table.Cell>{asset.type}</Table.Cell>
              <Table.Cell>{asset.status}</Table.Cell>
              <Table.Cell>{asset.model}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default observer(EmployeeAssetList);
